import { useCallback, type RefObject } from 'react';
import type { VideoPresentation } from '../../../renderer/src/video-presentation';
import { socialCameraPadding } from '../render/social-camera-padding';
import { legacyPlateCameraPadding } from '../render/legacy-plate-camera-padding';
import { useOverlayCameraPadding } from './use-overlay-camera-padding';

export function useCompositionCameraPadding(root: RefObject<HTMLElement | null>, presentation: VideoPresentation | undefined) {
  const enabled = presentation?.version === 2 || presentation?.plateTransparency !== undefined || presentation?.textColor !== undefined;
  // Playback derives new presentation objects; only changed settings restart the layout measurement.
  const revision = JSON.stringify(presentation);
  const measure = useCallback((element: HTMLElement) => !presentation ? undefined
    : presentation.version === 2 ? socialCameraPadding(element, presentation, window.innerWidth, window.innerHeight)
      : legacyPlateCameraPadding(element, window.innerWidth, window.innerHeight), [revision]);
  return useOverlayCameraPadding(root, enabled, measure);
}
